import { configureStore } from '@reduxjs/toolkit'
import userReducer from "./reducers/user"
import errorReducer from "./reducers/errors"
import popupReducer from "./reducers/popup"
import configReducer from "./reducers/config"
import { createLogger } from 'redux-logger'

const logger: any = createLogger();

export const store = configureStore({
  reducer: {
    user: userReducer,
    error: errorReducer,
    popup: popupReducer,
    config: configReducer
  },
  middleware: (getDefaultMiddleware) => {
    if (process.env.NODE_ENV === "development"){
      return getDefaultMiddleware().concat(logger)
    }
    return getDefaultMiddleware()
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch